export type AnalyticsPayload = Record<string, unknown> | undefined;

type AnalyticsWindow = Window & {
  dataLayer?: Array<Record<string, unknown>>;
  gtag?: (...args: unknown[]) => void;
};

const isBrowser = typeof window !== 'undefined';

const pushToDataLayer = (event: string, payload?: Record<string, unknown>) => {
  if (!isBrowser) return false;
  const analyticsWindow = window as AnalyticsWindow;
  if (!Array.isArray(analyticsWindow.dataLayer)) {
    return false;
  }
  analyticsWindow.dataLayer.push({ event, ...(payload ?? {}) });
  return true;
};

const pushToGtag = (event: string, payload?: Record<string, unknown>) => {
  if (!isBrowser) return false;
  const analyticsWindow = window as AnalyticsWindow;
  if (typeof analyticsWindow.gtag !== 'function') {
    return false;
  }
  analyticsWindow.gtag('event', event, payload ?? {});
  return true;
};

export const trackAnalyticsEvent = (event: string, payload?: AnalyticsPayload) => {
  const normalisedPayload = payload ?? {};
  if (pushToDataLayer(event, normalisedPayload)) {
    return;
  }
  if (pushToGtag(event, normalisedPayload)) {
    return;
  }
  if (process.env['NODE_ENV'] !== 'production') {
    // eslint-disable-next-line no-console -- useful during development when analytics is unavailable
    console.debug('[analytics]', event, normalisedPayload);
  }
};
